import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function HoursLocation() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-cream relative" data-id="element-257">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16" data-id="element-259">
          {/* Location Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-260">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-6 md:mb-8" data-id="element-261">
              {t('hours.title')}
            </h2>

            <div className="space-y-8" data-id="element-262">
              <div className="flex items-start gap-4" data-id="element-263">
                <div className="bg-white p-3 rounded-full shadow-sm text-brand-gold" data-id="element-264">
                  <MapPin className="w-6 h-6" data-id="element-265" />
                </div>
                <div data-id="element-266">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-267">
                    {t('hours.location')}
                  </h3>
                  <p className="text-gray-600" data-id="element-268">Phenix Salon Suite (#114)</p>
                  <p className="text-gray-600" data-id="element-269">100 Broadway</p>
                  <p className="text-gray-600" data-id="element-270">Elmwood Park, NJ 07407</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-271">
                <div className="bg-white p-3 rounded-full shadow-sm text-brand-gold" data-id="element-272">
                  <Phone className="w-6 h-6" data-id="element-273" />
                </div>
                <div data-id="element-274">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-275">
                    {t('hours.contact')}
                  </h3>
                  <a href="tel:5513328938" className="text-brand-gold hover:text-brand-gold-light font-medium text-xl transition-colors" data-id="element-276">
                    (551) 332-8938
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Hours Table */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-sm shadow-lg border border-brand-gold/10" data-id="element-277">
            <div className="flex items-center gap-3 mb-8" data-id="element-278">
              <Clock className="w-6 h-6 text-brand-gold" data-id="element-279" />
              <h3 className="text-2xl font-serif text-brand-brown" data-id="element-280">
                {t('hours.hours_title')}
              </h3>
            </div>

            <div className="space-y-4" data-id="element-281">
              <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-282">
                <span className="font-medium text-brand-charcoal" data-id="element-283">
                  {t('hours.mon_fri')}
                </span>
                <span className="text-gray-600" data-id="element-284">9:00 AM – 7:00 PM</span>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-285">
                <span className="font-medium text-brand-charcoal" data-id="element-286">
                  {t('hours.sat')}
                </span>
                <span className="text-gray-600" data-id="element-287">9:00 AM – 8:00 PM</span>
              </div>
              <div className="flex justify-between items-center py-3" data-id="element-288">
                <span className="font-medium text-brand-charcoal" data-id="element-289">
                  {t('hours.sun')}
                </span>
                <span className="text-gray-600" data-id="element-290">10:00 AM – 4:30 PM</span>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-brand-gold/20 text-center" data-id="element-291">
              <p className="text-sm text-brand-brown font-medium" data-id="element-292">
                {t('hours.footer')}
              </p>
            </div>
          </motion.div>
        </div>

        {/* Interactive Google Map */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-10 md:mt-16 rounded-sm overflow-hidden shadow-lg border border-brand-gold/10" data-id="element-293">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3014.84615485456!2d-74.1232019!3d40.919118999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2fddb78ca8225%3A0xe90d5f6a3e2244e5!2z8J2Vi_CdlLjwnZWA4oSd8J2VjCDwnZS44J2UvPCdlYrwnZWL4oSN8J2UvPCdlYvwnZWA4oSC8J2Vig!5e0!3m2!1ses-419!2sus!4v1777744988187!5m2!1ses-419!2sus" width="100%" height="350" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Tairu Aesthetics - Phenix Salon Suite, Elmwood Park NJ" className="w-full" data-id="element-294"></iframe>
        </motion.div>
      </div>
    </section>;
}